export const objectToFormData = (object: Record<string, any>) => {
  const isObject = (obj: Record<string, any>) =>
    typeof obj === 'object' && !(obj instanceof Date) && !(obj instanceof File) && obj !== null

  const appendObject = (parentKey: string, obj: Record<string, any>, formData: FormData) => {
    for (const key in obj) {
      const value = obj[key]

      if (isObject(value)) {
        appendObject(`${parentKey}[${key}]`, value, formData)
      } else if (value !== undefined) {
        formData.append(`${parentKey}[${key}]`, value === null ? '' : value)
      }
    }
  }

  const formData = new FormData()

  for (const key in object) {
    const value = object[key]

    if (value instanceof File) {
      formData.append(key, value, value.name)
    } else if (value !== undefined) {
      if (isObject(value)) {
        appendObject(key, value, formData)
      } else {
        formData.append(key, value === null ? '' : value)
      }
    }
  }

  return formData
}

export const buildUrl = (url: string, params?: Record<string, any>): string => {
  if (!params) {
    return url
  }

  const entries = []
  for (const key in params) {
    entries.push(encodeURIComponent(key) + '=' + encodeURIComponent(params[key]))
  }

  return `${url}?${entries.join('&')}`
}
